<template>
  <div class="profit-loss-main">
    
    <div class="option-container">  
      <DateTimePicker style="margin-left: 10px" title="From" :showTime="false" :value.sync="fromDate" :maxDate="toDate"/>
      <DateTimePicker style="margin: 3px 5px" title="To" :showTime="false" :value.sync="toDate" :minDate="fromDate"/>
      <div class="button-container">
        <button @click="optionClicked('Month')">By Month</button>
        <button @click="optionClicked('Customer')">By Customer</button>
        <button @click="optionClicked('Vehicle')">By Vehicle</button>
        <button @click="optionClicked('Cost Code')">By Cost Code</button>
        <button @click="optionClicked('Sales Person')">By Sales Person</button>
      </div>

      <span class="refresh-last">Last Refreshed: {{refreshDate}}</span>
    </div>

    <div class="title" style="background-color: white; width: 100%; border-radius: 5px 5px 0 0; margin-top: 3px;">
      <span style="font-size: 12px; font-weight: bold; margin-left: 10px"> Profit & Loss by {{ optionsBy }} </span>
    </div>

    <div class="chart-table">
      <div id="chart-container">
        <div class="ct-chart-PL" id="chart"> </div>
      </div>
      <div class="ct-chart-legend-PL" id="legend"></div>
    </div>
    
    <div class="table" id="tableChart" style="margin-right: 100px">
      <table class="details-table">
        <tr>
          <th :style="{ border: '1px solid black', padding: '3px !important' }"></th>
          <th :style="{ border: '1px solid black', padding: '3px !important' }" v-for="t in tableHeader" :key="t">{{ t }}</th>
        </tr>
        <tr v-for="a in allSeries" :key="a">
          <td :style="{ textAlign: 'left', border: '1px solid black', padding: '3px !important' }">
            <span style="font-weight: bold;">{{ a.name }}</span>
            <br>
            <a @click="drillThroughClicked('DETAILS_MONTH', a.name)" 
              style="cursor: pointer; text-decoration: underline; margin-right: 5px;">
              by GL Account
            </a> 
            | 
            <a @click="drillThroughClicked('TXN_MONTH', a.name)" 
              style="cursor: pointer; text-decoration: underline; margin-left: 5px;">
              by Transaction
            </a>
          </td>
          <td v-for="d in a.data" :key="d" :style="{ border: '1px solid black', padding: '3px !important' }">{{ d }}</td>
        </tr>
      </table>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context"/>
    <Loader :loadingText="loadText" :isVisible.sync="loading" />
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Tabulator from '@/components/Tabulator.vue';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    Loader, DateTimePicker, Tabulator, ContextMenu
  },
  data: function() { // local/private
    return {
      loadText: 'Loading',
      
      fromDate: new Date(new Date().getFullYear(), 0, 1), // first day of current year
      toDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), // last day of current month
      refreshDate: new Date(),

      loading: false,
      pnlAnalysis: [],
      item: [],

      chartLine: null,
      optionsBy: 'Month',

      fromDateRange: new Date(),
      toDateRange: new Date(),

      ser: '',
      getType: '',
      dateTitle: 'Date',
      titleTabulator: '',

      customLegend: [],
      allSeries: [],
      tableHeader: [],

      showContextMenu: false,
      contextItems: [ '[Series] by GL Account', '[Series] Details by Transaction' ],
      contextPosition: [ 100, 100 ]
    }
  },
  props: {
  },
  methods: {
    drillThroughClicked: async function(rptType, series) {
      this.loadText = `Getting details`;
      this.loading = true;
      
      var dataToPost = {
        'startdate': this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd'),
        'enddate':  this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd'),
        'rpttype': rptType,
        'series': series,
      }
      
      var ser;
      if(series.includes('/'))
        ser = series.replace('/',' ');

      sessionStorage.setItem(`Drill Through - ${rptType == 'DETAILS_MONTH' ? 'DETAILS_MONTH' : 'TXN_MONTH'} ${series.includes('/') ? ser : series}`, JSON.stringify({ data: dataToPost, series: series }));
      var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Profit & Loss/Drill Through - ${rptType == 'DETAILS_MONTH' ? 'DETAILS_MONTH' : 'TXN_MONTH'} ${series.includes('/') ? ser : series}`);
      window.open(drillThroughLink.href, '_blank');

      this.loading = false;
    },
    contextSelected: function(item) {
      this.drillThroughClicked(item.includes('Account') ? 'DETAILS_MONTH' : 'TXN_MONTH', item.includes('Account') ? item.replace(' by GL Account','') : item.replace(' Details by Transaction',''));
    },
    optionClicked: function(item) {
      this.optionsBy = item;
      this.createChart(item);
    },
    createChart: async function (item) {
      this.loading = true;
      this.refreshDate = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');

      this.allSeries = [];
      this.tableHeader = [];
      
      var rptType = item.toUpperCase().split(' ').join('');
      this.pnlAnalysis = await this.$apiCallV2(`/ProfitLossDashboard/GetPNLAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=${rptType}`);
      
      console.log(this.pnlAnalysis);
      
      this.loading = false;

      if(this.chartLine)
        this.chartLine.detach();

      var table = document.getElementsByClassName('table');
     
      document.getElementById('chart-container').innerHTML = "";
      document.getElementById('legend').innerHTML = "";

      if(this.pnlAnalysis.includes('error'))
        document.getElementById('chart-container').innerHTML = "<div class=\"ct-chart-PL\" id=\"chart\" style=\"width: 100%; height: 100%\"> </div><div v-if=\"pnlAnalysis.length == 0 \" style=\"text-align: center; font-size: 12px; font-weight: bold; margin-top: -25%; margin-left: 10%; width: 100%;\">An error occurred. Please try again.</div>";
      else if(this.pnlAnalysis.length == 0)
        document.getElementById('chart-container').innerHTML = "<div class=\"ct-chart-PL\" id=\"chart\" style=\"width: 100%; height: 100%\"> </div><div v-if=\"pnlAnalysis.length == 0 \" style=\"text-align: center; font-size: 12px; font-weight: bold; margin-top: -25%; margin-left: 10%; width: 100%;\">No records found.</div>";
      else {
        document.getElementById('chart-container').innerHTML = "<div class=\"ct-chart-PL\" id=\"chart\" style=\"width: 100%; height: 100%\"> </div>";

        if (rptType == "MONTH") {

          // if year or month of fromDate doesn't match with year or month of first element in the pnlAnalysis array,
          // update it to the FIRST day of that month
          let fromYearMonth = this.pnlAnalysis[0].XAxis.split("-");
          if (this.fromDate.getFullYear() != fromYearMonth[0] || this.fromDate.getMonth() + 1 != parseInt(fromYearMonth[1]))
            this.fromDate = new Date(fromYearMonth[0], parseInt(fromYearMonth[1]) - 1);

          // if year or month of toDate doesn't match with year or month of last element in the pnlAnalysis array,
          // update it to the LAST day of that month

          let toYearMonth = this.pnlAnalysis[this.pnlAnalysis.length - 1].XAxis.split("-")
          if (this.toDate.getFullYear() != toYearMonth[0] || this.toDate.getMonth() + 1 != parseInt(toYearMonth[1]))
            this.toDate = new Date(toYearMonth[0], parseInt(toYearMonth[1]), 0);
        }
      }

      var formatCurrency = new Intl.NumberFormat();
      var someDiv = document.getElementById('legend');
      var dynamicSeriesName = Object.keys(this.pnlAnalysis[0]).filter((o) => { return o != 'XAxis' && o != 'XAxisDesc' });
      var dynamicSeries = dynamicSeriesName.map((d) => {
        return {
          name: d,
          data: this.pnlAnalysis.map((p) => { return p[d] })
        }
      });
      
      var value = dynamicSeriesName.map((d) => {
        return {
          data: Math.max(...this.pnlAnalysis.map((p) => { return p[d] }))
        }
      });
      var maxValue = Math.max(...value.map((p) => { return p.data }));
      
      var widthValue;
      if(this.pnlAnalysis.length < 2)
        widthValue = 1050;
      else if (this.pnlAnalysis.length < 3)
        widthValue = 525;
      else if (this.pnlAnalysis.length < 4)
        widthValue = 350;
      else if (this.pnlAnalysis.length < 5)
        widthValue = 263;
      else if (this.pnlAnalysis.length < 6)
        widthValue = 210;
      else if (this.pnlAnalysis.length < 7)
        widthValue = 175;
      else if (this.pnlAnalysis.length < 8)
        widthValue = 150;
      else if (this.pnlAnalysis.length < 9)
        widthValue = 130;
      else if (this.pnlAnalysis.length < 10)
        widthValue = 115;
      else if (this.pnlAnalysis.length < 11)
        widthValue = 105;
      else if (this.pnlAnalysis.length < 12)
        widthValue = 95;
      else if (this.pnlAnalysis.length < 13)
        widthValue = 87;
      else
        widthValue = 70;

      var chart = new Chartist.Line('.ct-chart-PL', {
        labels: this.pnlAnalysis.map((p) => { return p['XAxisDesc'] }),
        series: dynamicSeries
      }, {
        chartPadding: {top: 30, right: 30, bottom: 30, left: 30},
        high: maxValue,
        width: `${this.pnlAnalysis.length * widthValue}px`,
        axisY: {scaleMinSpace: 20},
        axisX: { 
          showLabel: true,
        },
        plugins: [
          Chartist.plugins.legend( { position: someDiv, clickable: true, className: "PL"} ),
        ]
      });

      if(rptType == 'MONTH'){
        var seq = 0,
        delays = 10,
        durations = 5;

        chart.on('created', function() {
          seq = 0;
        });

        chart.on('draw', function(data) {
          seq++;

          if(data.type === 'line') {
            data.element.animate({
              opacity: {
                begin: seq * delays + 1000,
                dur: durations,
                from: 0,
                to: 1
              }
            });
          } else if(data.type === 'label' && data.axis === 'x') {
            data.element.animate({
              y: {
                begin: seq * delays,
                dur: durations,
                from: data.y + 100,
                to: data.y,
                easing: 'easeOutQuart'
              }
            });
          } else if(data.type === 'label' && data.axis === 'y') {
            data.element.animate({
              x: {
                begin: seq * delays,
                dur: durations,
                from: data.x - 100,
                to: data.x,
                easing: 'easeOutQuart'
              }
            });
          } else if(data.type === 'point') {
            data.element.animate({
              x1: {
                begin: seq * delays,
                dur: durations,
                from: data.x - 10,
                to: data.x,
                easing: 'easeOutQuart'
              },
              x2: {
                begin: seq * delays,
                dur: durations,
                from: data.x - 10,
                to: data.x,
                easing: 'easeOutQuart'
              },
              opacity: {
                begin: seq * delays,
                dur: durations,
                from: 0,
                to: 1,
                easing: 'easeOutQuart'
              }
            });
          } else if(data.type === 'grid') {
            var pos1Animation = {
              begin: seq * delays,
              dur: durations,
              from: data[data.axis.units.pos + '1'] - 30,
              to: data[data.axis.units.pos + '1'],
              easing: 'easeOutQuart'
            };

            var pos2Animation = {
              begin: seq * delays,
              dur: durations,
              from: data[data.axis.units.pos + '2'] - 100,
              to: data[data.axis.units.pos + '2'],
              easing: 'easeOutQuart'
            };

            var animations = {};
            animations[data.axis.units.pos + '1'] = pos1Animation;
            animations[data.axis.units.pos + '2'] = pos2Animation;
            animations['opacity'] = {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'easeOutQuart'
            };

            data.element.animate(animations);
          }
        });

        chart.on('created', function() {
          if(window.__exampleAnimateTimeout) {
            clearTimeout(window.__exampleAnimateTimeout);
            window.__exampleAnimateTimeout = null;
          }
          window.__exampleAnimateTimeout = setTimeout(chart.update.bind(chart), 1200000);
        });
      }

      this.chartLine = chart;

      var dynamicSeries = dynamicSeriesName.map((d) => {
        return {
          name: d,
          data: this.pnlAnalysis.map((p) => { return p[d] = formatCurrency.format(p[d]) })
        }
      });
    
      this.allSeries = dynamicSeries;
      this.tableHeader = this.pnlAnalysis.map((p) => { return p['XAxisDesc'] });
      
      var $tooltip = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.ct-chart-PL'));
      $(document).on('mouseenter', '.ct-point', function() {
        var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');

        $tooltip.html("<span>" + seriesName + "<br/> " + formatCurrency.format(value) + "</span>");
        $tooltip.removeClass('tooltip-hidden');
      });

      $(document).on('mouseleave', '.ct-point', function() {
        $tooltip.addClass('tooltip-hidden');
      });

      $(document).on('mousemove', '.ct-point', function(event) {
        $tooltip.css({
          left: event.pageX - 60,
          top: event.pageY - 100
        });
      });

      var mainContainer = this;
      var series;
      $(document).ready(() => {
        $(document).on('click', '.ct-line', function(e) {
          series = $(this).closest('.ct-series').attr('ct:series-name');
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ series+ ' by GL Account', series + ' Details by Transaction' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 100), e.clientX + 15];
          });
        });

        $(document).on('click', '.ct-point', function(e) {
          series = $(this).closest('.ct-series').attr('ct:series-name');
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ series+ ' by GL Account', series + ' Details by Transaction' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 100), e.clientX + 15];
          });
        });
      });
    }
  },
  watch: {
    fromDate: function(val) {
      this.$emit('update:fromDate', val);
    },
    toDate: function(val) {
      this.$emit('update:toDate', val);
    }
  },
  async mounted() {
    this.loading = true;
    this.createChart('Month');
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.profit-loss-main{
  padding: 10px 45px;
  height: 100%;
  border-radius: 5px;

  > .option-container {
      display: flex;
      background-color: white;
      border-radius: 5px;
      margin-top: -5px;
      
    >.button-container{
      width: calc(100% - 300px);

      > button {
        height: fit-content;
        margin: 1px 3px;
      }
    }

    > .refresh-last{
      width: 300px;
      font-size: 12px;
      text-align: end;
      padding: 5px;
    }
  }
}
.chart-table{
  width: 100%; 
  height: 50%; 
  display:flex;
  background-color: white;
  border-radius: 0 0 5px 5px;
}

#chart-container{
  width: 100%;
  height: 100%;
  overflow-x: scroll;
}

.ct-chart-legend-PL{
  width: 20%;
  height: 100%;
}

.table {
  background-color: white;
  border-radius: 5px;
  height: calc(100% - 60%);
  width: 100%;
  padding-top: 5px;
  color: black;
  font-size: 12px;
  font-family: Oxigen, Helvetica, Arial;
  overflow-x: scroll;
  margin-top: 3px;

  > .details-table {
    width: 100%;
    border: 1px solid black;
    margin: 10px;
  }
}

table, td, th {
  border: 1px solid black;
  min-width: 70px;
}

td{
	text-align: right;
}

tr:nth-child(1){
	text-align: center;
}

tr td:nth-child(1){
  font-weight: bold;
}
tr:nth-child(2) td:nth-child(1){ 
	background-color: #ff6358;
}
tr:nth-child(3) td:nth-child(1){
	background-color: #ffd246;
}
tr:nth-child(4) td:nth-child(1){
	background-color: #28b4c8;
}
tr:nth-child(5) td:nth-child(1){
	background-color: #49ff2f;
}
tr:nth-child(6) td:nth-child(1){
	background-color: #b773f5;
}
tr:nth-child(7) td:nth-child(1){
	background-color: #2d73f5;
}
tr:nth-child(8) td:nth-child(1){
	background-color: #ff2113;
}
tr:nth-child(9) td:nth-child(1){
	background-color: #ff72b3;
}
tr:nth-child(10) td:nth-child(1){
	background-color: #dcd89e ;
}
tr:nth-child(11) td:nth-child(1){
	background-color: #6cf6e0;
}
tr:nth-child(12) td:nth-child(1){
	background-color: #eb7614;
}
tr:nth-child(13) td:nth-child(1){
	background-color: #1f65e1;
}
tr:nth-child(14) td:nth-child(1){
	background-color: #78d237;
}
tr:nth-child(15) td:nth-child(1){
	background-color: #0aadf6;
}
tr:nth-child(16) td:nth-child(1){
	background-color: #DAF7A6;
}
tr:nth-child(17) td:nth-child(1){
	background-color: #fafe13;
}
tr:nth-child(18) td:nth-child(1){
	background-color: #d4ccfe;
}
tr:nth-child(19) td:nth-child(1){
	background-color: #FFA07A;
}
tr:nth-child(20) td:nth-child(1){
	background-color: #2471A3 ;
}
tr:nth-child(21) td:nth-child(1){
	background-color: #B3B6B7;
}
tr:nth-child(22) td:nth-child(1){
	background-color: #afeeee;
}
tr:nth-child(23) td:nth-child(1){
	background-color: #ffc0cb;
}
tr:nth-child(24) td:nth-child(1){
	background-color: #b6fcd5;
}
tr:nth-child(25) td:nth-child(1){
	background-color: #c6e2ff;
}
tr:nth-child(26) td:nth-child(1){
	background-color: #fa8072;
}
</style>